<template lang="pug">
modal#set-permission-profile-user-modal(
  :buttonColor='true'
  :close-button-label='$t("button.cancel")'
  :disableProcessButton='loading || selectedProfile.length === 0'
  :loading='loading'
  :process-button-label='processButtonLabel'
  :title='title'
  @closed='onCloseModal'
  @opened='onOpenModal'
  @process='handleProcess'
  ref='modal'
  size='lg'
)
  .span.text(style='font-weight: 700') {{ $t('usersGuestCardTable.user') }} : {{ userName }}
  .span.text {{ message }}
  .contact-list
    .row.gx-3.gy-2.mt-3
      .col-12.col-sm-6(:key='profile.id' v-for='profile in profilesList.data')
        label.d-flex.align-items-center.contact-list-item(
          :for='`permission-profile-${profile.id}`'
        )
          input.checkbox.form-check-input(
            :disabled='loading'
            :id='`permission-profile-${profile.id}`'
            :value='profile.id'
            type='checkbox'
            v-model='selectedProfile'
          )
          .contact-info.d-flex.flex-column.ms-2
            span.ms-2 {{ getProfileName(profile.name) }}
            span.ms-2 {{ profile.description }}
    simple-paginator.pagination-space.mt-4(
      :payload='profilesList'
      @navigate='$emit("navigate-profiles", $event)'
    )
</template>

<script>
import Modal from '@/ui/molecules/Modal.vue';
import UsersService from '@/modules/business/services/http/organizations/users/UsersService';
import SimplePaginator from '@/ui/organisms/SimplePaginator.vue';
import PermissionsService from '@/services/PermissionsService';

export default {
  name: 'SetPermissionProfileUserModal',
  props: {
    userId: [Number, String],
    userRoles: {
      type: Array,
      default: () => [],
    },
    userName: {
      type: String,
      default: '',
    },
    isOwner: Boolean,
    roleName: String,
    profilesList: {
      type: Object,
      default: () => ({
        data: [],
        links: {},
        meta: {},
      }),
    },
  },
  components: {
    SimplePaginator,
    Modal,
  },
  computed: {
    title() {
      return this.$t('modal.setPermissionProfileUser.title');
    },
    message() {
      return this.$t('modal.setPermissionProfileUser.message');
    },
    processButtonLabel() {
      return this.$t('modal.setPermissionProfileUser.processButtonLabel');
    },
  },
  data() {
    return {
      loading: false,
      selectedProfile: [],
    };
  },
  methods: {
    async handleProcess() {
      this.loading = true;
      try {
        const data = { roles: [...this.selectedProfile] };
        await UsersService.changeUserRolesProfile(this.userId, data);
        this.closeModal();
      } finally {
        this.loading = false;
      }
    },
    onOpenModal() {
      this.selectedProfile = [...this.userRoles];
    },
    closeModal() {
      this.$emit('refresh');
      this.$refs.modal.close();
    },
    getProfileName(name) {
      const translationKeys = PermissionsService.rolesTranslationsKeys;
      const key = translationKeys[name];
      return key ? this.$t(key) : name;
    },
    onCloseModal() {
      this.selectedProfile = [];
    },
  },
};
</script>
<style lang="stylus">
#set-permission-profile-user-modal
  .contact-list
    > .row
      > .col-12
        display: flex
        > .contact-list-item
          flex: 1
  .contact-list-item
    border-radius: 3px
    padding: 0.54rem 1rem
    box-shadow: 0px 0px 3px 1px #dadada
    cursor: pointer
    position: relative
    padding-left: 1.7rem
    white-space: normal
    overflow: visible
    text-overflow: clip
    height: auto
    color: #555555
    width: 100%
    font-size: 0.875rem
    .contact-info
      flex: 1
      min-width: 0
      > span
        white-space: normal
        overflow-wrap: anywhere
      > span:first-child
        font-weight: 700
    .checkbox
      position: absolute
      left: 7px
      top: 0.7rem
.pagination-space
  display: inline-block
</style>
